// import React, { Component } from 'react';
// import HomeView from './HomeView';

// class HomeComponent extends Component {
// 	 state = {
//         modal_show: false,
//         post_modal_show: false,
//     }

//     hideCalculator = () => {
//         this.setState({ modal_show: false })
//     }

//     showCalculator = () => {
//         this.setState({ modal_show: true })
//     }
//      hidePostJobModal = () => {
//         this.setState({ post_modal_show: false })
//     }

//     showPostJobModal = () => {
//         this.setState({ post_modal_show: true })
//     }
//     render() {
//         return (<HomeView 
//         		modal_show={this.state.modal_show}
//                 showCalculator={this.showCalculator}
//                 hideCalculator={this.hideCalculator}
//                 post_modal_show={this.state.post_modal_show}
//                 hidePostJobModal={this.hidePostJobModal}
//         	/>)
//     }
// }

// export default HomeComponent;


import React, {useState} from 'react';

import HomeView from './HomeView';

function HomeComponent() {
  const [modalShow, setModalShow] = useState(false);
  const [postModalShow, setPostModalShow] = useState(false);

  const hideCalculator = () => {
    setModalShow(false);
  };

  const showCalculator = () => {
    setModalShow(true);
  };

  const hidePostJobModal = () => {
    setPostModalShow(false);
  };

  const showPostJobModal = () => {
    setPostModalShow(true);
  };

  return (
    <HomeView
      modal_show={modalShow}
      showCalculator={showCalculator}
      hideCalculator={hideCalculator}
      post_modal_show={postModalShow}
      hidePostJobModal={hidePostJobModal}
    />
  );
}

export default HomeComponent;
